// extracted by mini-css-extract-plugin
module.exports = {"tableNameColumn":"InstitutionsPage_tableNameColumn__1WHC9","infoMessageRow":"InstitutionsPage_infoMessageRow__2IhGZ"};